import ErrorIcon from "./components/ErrorIcon.js";
import InfoIcon from "./components/InfoIcon.js";
import NoFound from "./components/NoFound.js";
import NoPermission from "./components/NoPermission.js";
import ServerError from "./components/ServerError.js";
import SuccessIcon from "./components/SuccessIcon.js";
import WarningIcon from "./components/WarningIcon.js";
const IconMap = {
    success: SuccessIcon,
    error: ErrorIcon,
    info: InfoIcon,
    warning: WarningIcon,
    404: NoFound,
    500: ServerError,
    403: NoPermission
};
const rootClass = 'weet-components-result';
export { IconMap, rootClass };
